var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var ItemImageService = /** @class */ (function (_super) {
    __extends(ItemImageService, _super);
    function ItemImageService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this._subject = new Subject();
        return _this;
    }
    Object.defineProperty(ItemImageService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ItemImageService.prototype.checkItem = function (cols, rec) {
        var items = rec[cols[0].key] || [];
        var its = [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.image) || !this.colservice.checkVal(item.disp_flg)) {
                check = false;
            }
            its.push(item);
        }
        if (cols[0].required && its.length === 0) {
            check = false;
            this._subject.next(true);
        }
        return check;
    };
    ItemImageService.prototype.getDispFlg = function () {
        var _this = this;
        this.baseUrl = '/v1/gen/code-m-service?query={"predicateList":[{"name":"code_category_m.name","value":"boolFlg","operator":"eq"}],"orderByList":[{"name":"key","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.key, display: item.label });
            }
            _this.logger.debug('options:', options);
            return options;
        }));
    };
    ItemImageService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ItemImageService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return ItemImageService;
}(ContentBaseService));
export { ItemImageService };
var Item = /** @class */ (function () {
    function Item() {
        this.$type = "post" /* Post */;
        this.disp_flg = true;
    }
    return Item;
}());
export { Item };
//# sourceMappingURL=item-image.service.js.map